export default __webpack_public_path__ + "static/media/bold_icon_white.04714bac.svg";